module.exports = __webpack_public_path__ + "static/media/ltc.4bf70a8a.png";